import styled from 'styled-components'
import {
	themeObject,
	textModels,
	media,
	Breakpoints,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin-bottom: 32px;
	${media('margin: 0px 32px 0px 0px;', Breakpoints.ms)}
	${media('padding-right: 27px;', Breakpoints.xl)}
	&:last-child {
		margin-bottom: 0px;
		${media('margin: 0px;', Breakpoints.ms)}
	}
`
export const Info = styled.div`
	display: flex;
	flex-direction: column;
`
export const Title = styled.p`
	${textModels('heading', 'h3')}
	color: ${themeObject.colors.grey[800]};
	text-align: left;
	margin-bottom: 8px;
`
export const Text = styled.p`
	${textModels('text', 'l')}
	color: ${themeObject.colors.grey[600]};
	text-align: left;
`
